import React from "react";
import { Button, Dialog, Typography } from "@material-tailwind/react";
import { t } from "i18next";

interface MachineDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Dialogue de confirmation pour la suppression d'une machine
 */
export default function MachineDeleteDialog({
  open,
  onClose,
  onConfirm,
}: MachineDeleteDialogProps) {
  return (
    <Dialog open={open} handler={onClose} size="xs">
      <div className="p-4">
        <Typography variant="h5" className="mb-2">
          {t("Confirmation")}
        </Typography>
        <Typography className="mb-4">
          {t("Êtes-vous sûr de vouloir supprimer cette machine ?")}
        </Typography>
        <div className="flex justify-end gap-2">
          <Button
            onClick={onClose}
            variant="outlined"
            color="blue-gray"
            size="sm"
          >
            {t("Annuler")}
          </Button>
          <Button color="red" onClick={onConfirm} size="sm">
            {t("Supprimer")}
          </Button>
        </div>
      </div>
    </Dialog>
  );
} 